var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('div',[_c('div',{staticClass:"baseCalendar-date-picker",on:{"click":function($event){return _vm.$emit('click')}}},[_c('flat-pickr',{ref:"baseCalendar",attrs:{"config":_vm.config,"placeholder":_vm.placeholder},on:{"on-change":_vm.timeChanged},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b028abb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseCalendarPicker.vue
// module id = null
// module chunks = 